import styled from 'styled-components';

export const Wrapper = styled.div`
    margin: 0 auto;
    margin-top: 26px;
    @media only screen and (max-width: 400px) {
        text-align: center;
        width: 310px;
    }
`;

export const Text = styled.p`
    margin: 0;
    font-family: CoFoSansBold, Helvetica, sans-serif;
    font-size: 14px;
    line-height: 1.8;
    font-weight: 400;
    color: #fff;
    @media only screen and (max-width: 500px) {
        display: flex;
        flex-wrap: wrap;
    }
    @media only screen and (max-width: 407px) {
        display: flex;
        flex-wrap: wrap;
        line-height: 1.8;
    }
`;

export const Link = styled.a`
    margin-right: 5px;
    border-bottom: 1px dotted;
    font-family: CoFoSansBold, Helvetica, sans-serif;
    font-size: 14px;
    line-height: 1.2;
    font-weight: 400;
    color: #cce4fb;
    text-decoration: none;
    transition: color .2s linear;
    &:hover {
        color: #ed1c24;
        transition: color .2s linear;
    }
    @media only screen and (max-width: 500px) {
        line-height: unset
    }
    &:last-child{
        @media only screen and (max-width: 500px) {
        margin-left: 7px;
        }
    }
`;
